import { Component, ElementRef, OnInit } from '@angular/core';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { SharedService } from 'src/app/service/shared/shared.service';
import { ManpowerPlanVsActualPoupComponent } from 'src/app/shared/popups/manpower-plan-vs-actual-poup/manpower-plan-vs-actual-poup.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { saveAs } from 'file-saver';
import { HttpClient } from '@angular/common/http';
import { ConfirmationPopupComponent } from 'src/app/shared/popups/confirmation-popup/confirmation-popup.component';
import { jsPDF } from "jspdf";
import autoTable from 'jspdf-autotable';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-organizational-structure',
  templateUrl: './organizational-structure.component.html',
  styleUrls: ['./organizational-structure.component.scss'],
})
export class OrganizationalStructureComponent implements OnInit {
  loggedInUserCompanyID: any
  loggedInCompanyFiscalyear: any;
  loggedInUserId: any;
  buttonColorName: any;
  loggedInUserRole: any;
  selectedYear: any;
  fromYear: any;
  toYear: any;
  selectedMonth: any;
  onUpDownlaodArrow: boolean = false;
  onDownDownlaodArrow: boolean = true;
  loggedInCompanyMDID: any;
  companyYears: any = [];
  getYearMonth: any = [];
  organizationData: any[] = [];
  getDepartmentData: any = [];
  selectDepartment: any;
  vacantCount: any;
  showOnlyVacant: boolean = false;
  afterIsVacantShow: boolean = true;
  currentChartClass = 'org-chart';

  constructor(private el: ElementRef, private httpService: HttpService, private config: Config,
    private encryptionService: EncryptionService, public sharedService: SharedService, public dialog: MatDialog,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));
    this.loggedInCompanyFiscalyear = sessionStorage.getItem('loggedInCompanyFiscalyear');
    if (this.loggedInCompanyFiscalyear) {
      this.loggedInCompanyFiscalyear = this.encryptionService.decryptData(this.loggedInCompanyFiscalyear);
    }
    if (sessionStorage.getItem('loggedInCompanyMDID')) {
      this.loggedInCompanyMDID = this.encryptionService.decryptData(sessionStorage.getItem('loggedInCompanyMDID'));
    }
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    this.loggedInUserRole = sessionStorage.getItem('loggedInUserRole');
    if (this.loggedInUserRole) {
      this.loggedInUserRole = this.encryptionService.decryptData(this.loggedInUserRole);
    }
    window.onload = function () {
      const orgChart: any = document.querySelector('.org-chart');
      orgChart.scrollLeft = (orgChart.scrollWidth - orgChart.clientWidth) / 2;
      orgChart.scrollTop = (orgChart.scrollHeight - orgChart.clientHeight) / 2;
    };
  }

  ionViewWillEnter() {
    this.getpmsyearlist();
  }

  getpmsyearlist() {
    this.httpService.callGetService(this.config.getpmsyearlist + this.loggedInUserCompanyID).subscribe((data: any) => {
      this.companyYears = [];
      const currentYear = new Date().getFullYear();

      const filteredYearRanges = data?.data?.yearRanges?.filter((range: string) => {
        const [fromYear, toYear] = range.split('_').map(Number);

        if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
          return toYear <= currentYear;
        } else {
          return fromYear <= currentYear;
        }
      });
      filteredYearRanges?.forEach((ele: any) => {
        var test = ele.split('_');
        let obj = {
          year: test[0] + '-' + test[1]
        };
        this.companyYears.push(obj);
      });
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); 
      let yearValue = '';
      if (this.loggedInCompanyFiscalyear === 'Jan_Dec') {
        yearValue = `${currentYear}-${currentYear}`;
      } else {
        yearValue = `${currentYear}-${currentYear + 1}`;
        if(this.loggedInCompanyFiscalyear === 'Apr_Mar'){
          if(currentMonth<3){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'July_Jun'){
          if(currentMonth<6){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
        if(this.loggedInCompanyFiscalyear === 'Oct_Sep'){
          if(currentMonth<9){
            yearValue = `${currentYear-1}-${currentYear}`;
          }else{
            yearValue = `${currentYear}-${currentYear + 1}`;
          }
        }
      }

      let selectedYearIndex = this.companyYears.findIndex((ele: any) => ele?.year === yearValue);
      if (selectedYearIndex === -1) {
        selectedYearIndex = 0;
      }

      this.selectedYear = this.companyYears[selectedYearIndex]?.year;
      var test = this.selectedYear?.split('-');
      this.fromYear = test[0];
      this.toYear = test[1];

      this.getFiscalYearMonths();
      this.getPMSMonth();
    });
  }

  onYearChange(event: any) {
    var selectedyear = event.value?.split('-');
    this.fromYear = selectedyear[0];
    this.toYear = selectedyear[1];

    this.getOrgStructure();
  }

  onMenuClose() {
    this.onUpDownlaodArrow = false;
    this.onDownDownlaodArrow = true;
  }

  onClickDownloadBtn() {
    this.onUpDownlaodArrow = true;
    this.onDownDownlaodArrow = false;
  }

  zoomLevel: number = 1;

  zoomIn() {
    this.zoomLevel += 0.1;
  }

  zoomOut() {
    if (this.zoomLevel > 0.2) {
      this.zoomLevel -= 0.1;
    }
  }

  toggleChildren(employee: any) {
    employee.showChildren = !employee.showChildren;
  }

  getFiscalYearMonths() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "fromYear": null,
      "toYear": null
    }
    this.httpService.callPostService(this.config.getFiscalYearMonths, request).subscribe((result: any) => {
      this.getYearMonth = result.data;

      const currentMonthIndex = new Date().getMonth();
      this.selectedMonth = this.getYearMonth[currentMonthIndex];
      this.getDeptForOrgStructure()
      this.getOrgStructure();
    })
  }


  onMonthChange(data: any) {
    if (data) {
      this.getDeptForOrgStructure()
      this.getOrgStructure()
    }
  }

  getDeptForOrgStructure() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "depts": null,
      "fromYear": this.fromYear,
      "month": this.selectedMonth,
      "toYear": this.toYear,
      "userId": this.loggedInCompanyMDID
    }
    this.httpService.callPostService(this.config.getDeptOrgStructure, request).subscribe((result: any) => {
      this.getDepartmentData = result.data;
      // this.getOrgStructure();
    })
  }


  getOrgStructure() {
    const request = {
      "companyId": this.loggedInUserCompanyID,
      "month": this.selectedMonth,
      "fromYear": this.fromYear,
      "toYear": this.toYear,
      "userId": this.loggedInCompanyMDID
    }
    this.httpService.callPostService(this.config.getOrgStructure, request).subscribe((result: any) => {
      if (result) {
        if (this.loggedInUserRole == 'Employee' || this.loggedInUserRole == 'Manager' || this.loggedInUserRole == 'HOD' || this.loggedInUserRole == 'Admin') {
          const orgData = result?.data;
          const id:any = Number(this.loggedInUserId)
          const filteredData = this.findMatchingDept(orgData, id);
          this.organizationData = filteredData ? [filteredData] : [];
          this.vacantCount = this.countVacantEmployees(this.organizationData);
        } else {
          this.organizationData = result.data;
          const id:any = this.organizationData.map((ele: any) => ele?.id);
          this.vacantCount = this.countVacantEmployees(this.organizationData);
        }
        if (this.selectDepartment) {
          // this.organizationData = this.filterByDepartment(this.organizationData, this.selectDepartment);
        }
      }
    });
  }

  // filterByDepartment(data: any[], department: string): any[] {
  //   return data
  //     .filter(item => item.department === department)
  //     .map(item => ({
  //       ...item,
  //       subordinates: item.subordinates ? this.filterByDepartment(item.subordinates, department) : []
  //     }));
  // }

  onChangeDepartment(data: any) {
    const selectedDepartment = data.value;

    // Recursive function to filter nodes based on the department
    const filterByDepartment = (nodes: any[], department: string): any[] => {
      return nodes
        .filter((node) => node.department === department || department === '')
        .map((node) => ({
          ...node,
          subordinates: filterByDepartment(node.subordinates || [], department),
        }))
        .filter((node) => node.department === department || node.subordinates.length > 0);
    };

    if (selectedDepartment) {
      this.organizationData = filterByDepartment(this.organizationData, selectedDepartment);
    } else {
      this.organizationData = [...this.organizationData];
    }
  }


  findMatchingDept(data: any[], loggedInUserId: number): any {
    for (const node of data) {
      if (node.id === loggedInUserId) {
        return node;
      }
      if (node.subordinates && node.subordinates.length > 0) {
        const matchingNode = this.findMatchingDept(node.subordinates, loggedInUserId);
        if (matchingNode) {
          return matchingNode;
        }
      }
    }
    return null;
  }

  countVacantEmployees(data: any[]): number {
    let count = 0;
    function traverse(subordinates: any[]): void {
      subordinates.forEach((employee) => {
        if (employee?.isVacant) {
          count++;
        }
        if (employee?.subordinates && employee?.subordinates.length > 0) {
          traverse(employee?.subordinates);
        }
      });
    }
    traverse(data);
    return count;
  }


  getInitials(name: string): string {
    if (!name) return '';
    const nameParts = name.trim().split(' ');
    const initials = nameParts.length > 1
      ? nameParts[0][0] + nameParts[nameParts.length - 1][0]
      : nameParts[0][0];
    return initials.toUpperCase();
  }

  countEmployeesUnderSubordinate(subordinate: any): number {
    if (!subordinate.subordinates || subordinate.subordinates.length === 0) {
      return 0;
    }
    let totalEmployees = 0;
    subordinate.subordinates.forEach((sub: any) => {
      totalEmployees += 1 + this.countEmployeesUnderSubordinate(sub);
    });

    return totalEmployees;
  }


  onClickOpenManpowerPlanVsActualPopup() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.height = '70%';
    dialogConfig.width = '100%';
    dialogConfig.data = {
      fromYear: this.fromYear,
      toYear: this.toYear,
      month: this.selectedMonth
    };
    dialogConfig.panelClass = 'custom-dialog-container';
    const dialogRef = this.dialog.open(ManpowerPlanVsActualPoupComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
    });
  }

  getMonthsByFiscalandReviewCycle: any;
  selectedYearReviewCycle: any;
  fromDate: any;
  toDate: any;
  selectedReviewCycle: any = [];
  getMonthsByFiscalandReviewCycleForReport: any = [];
  getAnnouncementTableData: any = [];

  getPMSMonth() {
    const request = {
      companyId: this.loggedInUserCompanyID,
      fromYear: this.fromYear,
      toYear: this.toYear
    }
    this.httpService.callPostService(this.config.getMonths, request).subscribe((data: any) => {
      this.selectedReviewCycle = [];
      this.getMonthsByFiscalandReviewCycleForReport = []
      this.getMonthsByFiscalandReviewCycle = data.data?.months;
      data.data?.months?.forEach((ele: any) => {
        let obj = {
          id: ele,
          name: this.sharedService.transform(ele)
        }
        this.getMonthsByFiscalandReviewCycleForReport.push(obj)
      });
      this.selectedYearReviewCycle = data.data?.reviewCycle;
      const currentMonthIndex = new Date().getMonth();
      let selectedIndex = 0;
      const today = new Date();
      const month = today.toLocaleString('default', { month: 'long' });
      if (this.selectedYearReviewCycle == 'Monthly') {
        this.getMonthsByFiscalandReviewCycle.forEach((ele: any) => {
          var checkMonth = ele?.split('-');
          if (month == checkMonth[0]) {
            this.fromDate = ele;
            this.toDate = ele;
            this.selectedReviewCycle.push({ id: ele, name: this.sharedService.transform(ele) });
          }
        });
      }

      if (this.selectedYearReviewCycle == 'Quarterly' || this.selectedYearReviewCycle == 'Semi_Annually'
        || this.selectedYearReviewCycle == 'Annually'
      ) {
        for (let range of this.getMonthsByFiscalandReviewCycle) {
          const [start, end] = range?.split('-');
          const startMonthIndex = this.getMonthIndex(start);
          const endMonthIndex = this.getMonthIndex(end);

          if (
            (currentMonthIndex >= startMonthIndex && currentMonthIndex <= endMonthIndex) ||
            (startMonthIndex > endMonthIndex && (currentMonthIndex >= startMonthIndex || currentMonthIndex <= endMonthIndex))
          ) {
            this.fromDate = range;
            this.toDate = range;
            this.selectedReviewCycle.push({ id: range, name: this.sharedService.transform(range) });
          }
        }
      }
    })
  }

  getMonthIndex(monthName: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return months.findIndex(month => month.toLowerCase() === monthName.toLowerCase());
  }


  onClickViewPDF(id: any) {
    const userIds = id
    const monthNames = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"];
    const currentMonthIndex = new Date().getMonth();
    const currentMonthName = monthNames[currentMonthIndex];
    const nextMonthName = monthNames[(currentMonthIndex + 1) % 12];
    const monthRange = `${currentMonthName}-${nextMonthName}`;

    const request = {
      "compId": this.loggedInUserCompanyID,
      "fromYear": this.fromYear,
      "month": [this.fromDate],
      "search": null,
      "toYear": this.toYear,
      "userId": [userIds]
    };
    this.httpService.callPostService(this.config.generateScoreCardPDFReportV2, request).subscribe((data: any) => {
      // var fileName = data?.data?.split(environment.downloadURL)
      // saveAs(data?.data, fileName[1]);

      if (data?.status == true) {
        this.http.get(data?.data, { responseType: 'blob' }).subscribe((blob: any) => {
          const url = URL.createObjectURL(blob);
          window.open(url, '_blank');
          setTimeout(() => URL.revokeObjectURL(url), 500);
        });
      } else {
        const dialogRef = this.dialog.open(ConfirmationPopupComponent, {
          disableClose: true,
          height: '25%',
          width: '30%',
          data: {
            msg: 'No score card report found',
            btn2: 'Ok',
            btn2BgColor: this.buttonColorName,
            showSuccessIcon: false,
            showSuccessMessage: false,
            showCloseIcon: false
          },
        });
        dialogRef.afterClosed().subscribe(result => {

        })
      }
    })
  }

  toggleVacantFilter() {
    // this.showOnlyVacant = true;
    // this.afterIsVacantShow =  false;

    if (!this.showOnlyVacant) {
      this.showOnlyVacant = true;
      this.afterIsVacantShow = false;
    } else {
      this.showOnlyVacant = false;
      this.afterIsVacantShow = true;
    }
  }

  onClickDisabledVacant() {
    this.showOnlyVacant = false;
    this.afterIsVacantShow = true;
  }

  isRowHidden(node: any): any {
    if (this.selectDepartment) {
      return (
        node.subordinates &&
        node.subordinates.every(
          (child: any) => child.department !== this.selectDepartment && this.selectDepartment
        )
      );
    }
  }

  areAllChildrenHidden(children: any[]): boolean {
    return children.every(
      (child: any) => child.department !== this.selectDepartment && this.selectDepartment
    );
  }


  exportTableToPDF(elementId: string) {
    this.currentChartClass = 'exportToPng';
    const element = document.getElementById(elementId);
    
    if (!element) {
      console.error('Element not found');
      return;
    }
  
    const originalWidth = element.scrollWidth;
    const originalHeight = element.scrollHeight;
  
    const MAX_CANVAS_SIZE = 52767;
    const scale = Math.min(1, MAX_CANVAS_SIZE / Math.max(originalWidth, originalHeight));
  
    setTimeout(() => {
      html2canvas(element, {
        width: Math.min(originalWidth, MAX_CANVAS_SIZE),
        height: Math.min(originalHeight, MAX_CANVAS_SIZE),
        scale: scale,
        useCORS: true,
        backgroundColor: null, 
        logging: false,
        allowTaint: true,
        ignoreElements: (element) => {
          return element.classList.contains('ignore-in-export');
        },
        onclone: (document) => {
          const clonedElement = document.getElementById(elementId);
          if (clonedElement) {
            clonedElement.style.backgroundColor = 'transparent';
            clonedElement.style.background = 'transparent';
          }
        }
      }).then((canvas) => {
        try {
          const imgData = canvas.toDataURL('image/png');
          
          if (!imgData || imgData.length < 100) {
            throw new Error('Invalid image data');
          }
  
          const pdf = new jsPDF('p', 'mm', 'a4');
          const pageWidth = pdf.internal.pageSize.width;
          const pageHeight = pdf.internal.pageSize.height;
          
          const imgWidth = pageWidth;
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          
          pdf.addImage(
            imgData, 
            'PNG', 
            0, 
            0, 
            imgWidth, 
            imgHeight, 
            '', 
            'FAST'
          );
          
          pdf.save('org_chart.pdf');
        } catch (error) {
          console.error('PDF export error:', error);
        }
      }).catch((err) => {
        console.error('Canvas rendering error:', err);
      });
    }, 200);
  
    setTimeout(() => {
      this.currentChartClass = 'org-chart';
    }, 1000);
  }

// This org chart with background color 
  exportToPng(elementId: string, fileName: string): void {
    const element = document.getElementById(elementId);
    this.currentChartClass = 'exportToPng';
  
    if (!element) {
      console.error('Element not found with ID:', elementId);
      return;
    }
  
    const originalWidth = element.scrollWidth;
    const originalHeight = element.scrollHeight;
  
    const MAX_CANVAS_SIZE = 52767;
    const scale = Math.min(1, MAX_CANVAS_SIZE / Math.max(originalWidth, originalHeight));
  
    setTimeout(() => {
      html2canvas(element, {
        width: Math.min(originalWidth, MAX_CANVAS_SIZE),
        height: Math.min(originalHeight, MAX_CANVAS_SIZE),
        scale: scale,
        useCORS: true,
        backgroundColor: '#FFFFFF', // Set white background
        logging: false,
        allowTaint: true,
        ignoreElements: (element) => {
          return element.classList.contains('ignore-in-export');
        },
        onclone: (document) => {
          const clonedElement = document.getElementById(elementId);
          if (clonedElement) {
            clonedElement.style.backgroundColor = 'white';
            clonedElement.style.background = 'white';
          }
        }
      })
      .then((canvas) => {
        canvas.toBlob((blob) => {
          if (blob) {
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${fileName}.png`;
            link.click();
            
            // Revoke the object URL to free up memory
            URL.revokeObjectURL(link.href);
          }
        }, 'image/png');
      })
      .catch((err) => {
        console.error('PNG export error:', err);
      });
    }, 200);
  
    setTimeout(() => {
      this.currentChartClass = 'org-chart';
    }, 2000);
  }
}
